module.exports = __webpack_public_path__ + "home-hero@2x-1sS9uod.jpg";